import { render, staticRenderFns } from "./kindChooseViewjpkcSeventh.vue?vue&type=template&id=05921c99&scoped=true"
import script from "./kindChooseViewjpkcSeventh.vue?vue&type=script&lang=js"
export * from "./kindChooseViewjpkcSeventh.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewjpkcSeventh.vue?vue&type=style&index=0&id=05921c99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05921c99",
  null
  
)

export default component.exports